export const getInUseCohortBuilderNamesForId = (
  id: string,
  inUseCohortBuilderItemsMap: Record<string, string[]> | undefined,
  cohortBuilderItemIdsToNamesMap: Record<string, string> | undefined
) => {
  const inUseItemsForThisCohortBuilderItem =
    inUseCohortBuilderItemsMap && inUseCohortBuilderItemsMap[id];
  return (
    cohortBuilderItemIdsToNamesMap &&
    inUseItemsForThisCohortBuilderItem?.map((inUseItem) => {
      return cohortBuilderItemIdsToNamesMap[inUseItem];
    })
  );
};
